
import { mdiOpenInNew } from '@mdi/js'
import { useStoryblokApi } from '@storyblok/nuxt-2'
import BlogArticleCard from '@/components/storyblok/blog/ArticleCard.vue'
import LandingageToolbar from '@/components/layout/LandingpageToolbar.vue'

export default {
  name: 'ArticlePage',
  auth: false,
  components: {
    BlogArticleCard,
    LandingageToolbar
  },
  layout: 'landingpage',
  data: () => ({
    mdiOpenInNew,
    articles: [],
  }),
  async created() {
    try {
      const isDraft = this.$route.query?._storyblok !== undefined
      const storyblokApi = useStoryblokApi()
      const locale = this.$i18n.locale
      const version = isDraft ? 'draft' : 'published'
      const { data } = await storyblokApi.get(
        `cdn/stories?fallback_lang=de&language=${locale}`,
        {
          version,
          starts_with: 'blog',
        }
      )
      this.articles = data.stories
    } catch (err) {
      console.warn(err)
    }
  },
}
